import * as airplay from './airplay';
import * as akamaiStats from './akamai-stats';
import * as androidFallback from './android-fallback';
import * as androidNative from './android-native';
import * as captions from './captions';
import * as chromecast from './chromecast';
import * as embed from './embed';
import * as errorHandler from './error-handler';
import * as fallbackOldDevice from './fallback-old-device';
import * as immersive from './immersive';
import * as iosNativeCC from './ios-native-cc';
import * as iosNative from './ios-native';
import * as keyboardNavigation from './keyboard-navigation';
import * as mediaPlayerStatistics from './media-player-statistics';
import * as mmsStats from './mms-stats';
import * as pictureinpicture from './pictureinpicture';
import * as splash from './splash';
import * as thumbnails from './thumbnails';
import * as ui from './ui';
import * as windowsPhoneFallback from './windows-phone-fallback';
import * as metrics from './metrics';

export {
    airplay,
    akamaiStats,
    androidFallback,
    androidNative,
    captions,
    chromecast,
    embed,
    errorHandler,
    fallbackOldDevice,
    immersive,
    iosNativeCC,
    iosNative,
    keyboardNavigation,
    mediaPlayerStatistics,
    metrics,
    mmsStats,
    pictureinpicture,
    splash,
    thumbnails,
    ui,
    windowsPhoneFallback
};



// WEBPACK FOOTER //
// ./src/js/plugins/index.js